import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';

export function login(data) {
    return dispatch => {
        return axios.post(kinetik_api_url + '/login', data);
    }
};

export const SET_PROVIDER_INFO = "SET_PROVIDER_INFO";
export function setProviderInfo(val) {
    return {
      type: SET_PROVIDER_INFO,
      payload: val
    };
  }
  


// WEBPACK FOOTER //
// ./src/app/login_page/login.action.js